import {  useEffect, useState, forwardRef, useImperativeHandle } from "react"
import { Grid2 } from "@mui/material"

export const ErrorSection = forwardRef(({text, autohide }, ref) => {
    const [showError, setShowError] = useState(false)
    useImperativeHandle(ref, () => {
        return {
            onShow() {
                setShowError(true)

            }
        }
    })
    useEffect(() => {
        if (showError && autohide) {

            setTimeout(function () {
                setShowError(false)

            }, autohide)
        }

    }, [showError])
    return (
        showError &&
        <Grid2 sx={{color: 'red'}}>{text}</Grid2>
        
    )
})